var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5740_31186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4997 6.97998C21.4797 6.97998 21.4497 6.97998 21.4197 6.97998C16.1297 6.44998 10.8497 6.24998 5.61967 6.77998L3.57967 6.97998C3.15967 7.01998 2.78967 6.71998 2.74967 6.29998C2.70967 5.87998 3.00967 5.51998 3.41967 5.47998L5.45967 5.27998C10.7797 4.73998 16.1697 4.94998 21.5697 5.47998C21.9797 5.51998 22.2797 5.88998 22.2397 6.29998C22.2097 6.68998 21.8797 6.97998 21.4997 6.97998Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99977 5.97C8.95977 5.97 8.91977 5.97 8.86977 5.96C8.46977 5.89 8.18977 5.5 8.25977 5.1L8.47977 3.79C8.63977 2.83 8.85977 1.5 11.1898 1.5H13.8098C16.1498 1.5 16.3698 2.88 16.5198 3.8L16.7398 5.1C16.8098 5.51 16.5298 5.9 16.1298 5.96C15.7198 6.03 15.3298 5.75 15.2698 5.35L15.0498 4.05C14.9098 3.18 14.8798 3.01 13.8198 3.01H11.1998C10.1398 3.01 10.1198 3.15 9.96977 4.04L9.73977 5.34C9.67977 5.71 9.35977 5.97 8.99977 5.97Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7104 23.0001H9.29039C5.80039 23.0001 5.66039 21.0701 5.55039 19.5101L4.90039 9.44007C4.87039 9.03007 5.19039 8.67008 5.60039 8.64008C6.02039 8.62008 6.37039 8.93008 6.40039 9.34008L7.05039 19.4101C7.16039 20.9301 7.20039 21.5001 9.29039 21.5001H15.7104C17.8104 21.5001 17.8504 20.9301 17.9504 19.4101L18.6004 9.34008C18.6304 8.93008 18.9904 8.62008 19.4004 8.64008C19.8104 8.67008 20.1304 9.02007 20.1004 9.44007L19.4504 19.5101C19.3404 21.0701 19.2004 23.0001 15.7104 23.0001Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1601 17.5H10.8301C10.4201 17.5 10.0801 17.16 10.0801 16.75C10.0801 16.34 10.4201 16 10.8301 16H14.1601C14.5701 16 14.9101 16.34 14.9101 16.75C14.9101 17.16 14.5701 17.5 14.1601 17.5Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 13.5H10C9.59 13.5 9.25 13.16 9.25 12.75C9.25 12.34 9.59 12 10 12H15C15.41 12 15.75 12.34 15.75 12.75C15.75 13.16 15.41 13.5 15 13.5Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5740_31186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBlack);
export default __webpack_public_path__ + "static/media/trashBlack.b49e130a32e27287dd3ecfdab1de136e.svg";
export { ForwardRef as ReactComponent };